import raf from 'raf'

export default class VoiceMeter {
  constructor (stream) {
    if (typeof AudioContext === 'undefined' || !AudioContext) {
      this.isSupported = false
      return
    }

    this.isSupported = true
    const audioContext = new AudioContext()
    this.analyser = audioContext.createAnalyser()
    this.analyser.minDecibels = -90
    this.analyser.maxDecibels = -10
    this.analyser.smoothingTimeConstant = 0.85
    this.analyser.fftSize = 256
    this.dataArrayAlt = new Uint8Array(this.analyser.frequencyBinCount)
    audioContext.createMediaStreamSource(stream).connect(this.analyser)
  }

  onChange (cb) {
    if (!this.isSupported) {
      return
    }

    this.hdl = raf(() => {
      this.onChange(cb)
    })
    this.analyser.getByteFrequencyData(this.dataArrayAlt)
    const volume = this.dataArrayAlt.reduce((a, b) => a + b, 0) / this.dataArrayAlt.length
    cb(volume)
  }

  stop () {
    if (this.hdl) {
      raf.cancel(this.hdl)
    }
  }
}
